<template>
    <v-app>
        <template v-if="authenticated">
            <nav-left-super-admin v-if="$route.path.includes('/superadmin')" />
            <nav-left v-else />
        </template>
        <v-main>
            <v-container fluid style="height: 100%!important;" class="pa-0">
                <v-row class="fill-height">
                    <template v-if="authenticated">
                        <v-col class="px-8 py-5">
                            <nav-top />

                            <router-view :key="$route.name + $route.path"></router-view>
                        </v-col>
                    </template>
                    <template v-else>
                        <v-col class="pa-0">
                            <router-view :key="$route.name + $route.path"></router-view>
                        </v-col>
                    </template>
                </v-row>
            </v-container>
        </v-main>

        <app-snack-bar ref="snackbar" />
    </v-app>
</template>

<script>
import NavLeft from './Base/Nav/Left';
import NavLeftSuperAdmin from './Base/Nav/LeftSuperAdmin';
import NavTop from './Base/Nav/Top';

import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            app_name: process.env.MIX_APP_NAME,
            data: {},
        };
    },

    components: {
        NavLeft,
        NavLeftSuperAdmin,
        NavTop
    },

    computed: {
        ...mapGetters({
            authenticated: 'auth/authenticated',
            user: 'auth/user',
        }),
    },

    mounted() {
        const theme = localStorage.getItem("darkTheme");

        if (theme) {
            if (theme === "true") {
                this.$vuetify.theme.dark = true;
            } else {
                this.$vuetify.theme.dark = false;
            }
        }
    }
};
</script>
